import { utils, type WorkSheet } from "xlsx";

export function fitWorksheetToContent(sheet: WorkSheet): void {
  let minC = Number.POSITIVE_INFINITY;
  let minR = Number.POSITIVE_INFINITY;
  let maxC = -1;
  let maxR = -1;

  for (const key of Object.keys(sheet)) {
    if (key[0] === "!") {
      continue;
    }
    if (!cellHasContent(sheet[key])) {
      continue;
    }
    let addr: { c: number; r: number };
    try {
      addr = utils.decode_cell(key);
    } catch {
      continue;
    }
    if (addr.c < minC) minC = addr.c;
    if (addr.r < minR) minR = addr.r;
    if (addr.c > maxC) maxC = addr.c;
    if (addr.r > maxR) maxR = addr.r;
  }

  if (maxC >= 0 && maxR >= 0) {
    sheet["!ref"] = utils.encode_range({ s: { c: minC, r: minR }, e: { c: maxC, r: maxR } });
  }
}

function cellHasContent(cell: WorkSheet[string] | undefined): boolean {
  if (!cell || typeof cell !== "object") {
    return false;
  }
  if ("f" in cell && cell.f) {
    return true;
  }
  if (!("v" in cell) || cell.v == null) {
    return false;
  }
  if (typeof cell.v === "string" && cell.v.trim() === "") {
    return false;
  }
  return true;
}
